import { env } from "./runtimeEnv";

export const authority = env("REACT_APP_AUTHORITY") || "https://keycloak.kube.elmis-soft.com/realms/aiutante";
export const clientId = env("REACT_APP_CLIENT_ID") || "aiutante-client";
export const baseUrl = env("REACT_APP_API_URL") || "https://dev.aiutante.elmis-soft.com";
